const Footer = () => {
    return (  
    
    <div id ="footer" className='text-center text-light' style={{ backgroundColor: '#fc5467' }}>
    © 2022 Copyright:  
    <a className='text-light' href='/'>
      {' '}  Scribbles.co
    </a>
     </div> 
  
  );
}
 
export default Footer;